import { AgencyDashboardActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  RightPanel_loading: false,
  LeftPanel_loading: false,
  BottonPanel_loading: false,
  DashboardData: {},
  OrganizationAuthorization: {},
  OrganizationEncounter: {},
  StaffEncounters: {},
  passwordExpiryMessage: null,
  passwordExpiryColorCode: null,
  OrganizationStaffDocuments: {},
  OrganizationClientDocuments: {},
  StaffDocuments: {},
  ClientDocuments: {},
  master_data: [],
  patientList: [],
  OrganizationBillableHoursGraph: {},
  OrganizationOAResponses: {},
  OrganizationFinancialKPIGraph: {},
  OrganizationPayerResponses: {},
  authorizationCptCode: null,
  authorizationUtilizationChartData: null,
  authorizationList: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case AgencyDashboardActionTypes.get_DashboardData.REQUEST:
      return {
        ...state,
      };
    case AgencyDashboardActionTypes.get_OrganizationAuthorization.REQUEST:
      return {
        ...state,
        RightPanel_loading: true,
      };
    case AgencyDashboardActionTypes.get_OrganizationEncounter.REQUEST:
    case AgencyDashboardActionTypes.get_StaffEncounter.REQUEST:
      return {
        ...state,
        BottonPanel_loading: true,
      };
    case AgencyDashboardActionTypes.get_DashboardData.SUCCESS:
      return {
        ...state,
        loading: false,
        DashboardData: payload,
      };
    case AgencyDashboardActionTypes.get_OrganizationAuthorization.SUCCESS:
      return {
        ...state,
        RightPanel_loading: false,
        OrganizationAuthorization: payload,
      };
    case AgencyDashboardActionTypes.get_OrganizationEncounter.SUCCESS:
      return {
        ...state,
        BottonPanel_loading: false,
        OrganizationEncounter: payload,
      };
    case AgencyDashboardActionTypes.get_StaffEncounter.SUCCESS:
      return {
        ...state,
        BottonPanel_loading: false,
        StaffEncounters: payload,
      };
    case AgencyDashboardActionTypes.get_CheckUserPasswordStatus.REQUEST:
      return {
        ...state,
        passwordExpiryMessage: null,
        passwordExpiryColorCode: null,
      };
    case AgencyDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS:
      return {
        ...state,        
        passwordExpiryMessage: payload.passwordExpiryStatus.status ? payload.passwordExpiryStatus.message : null,
        passwordExpiryColorCode: payload.passwordExpiryStatus.status ? payload.passwordExpiryStatus.colorCode : null,
      };
    case AgencyDashboardActionTypes.get_OrganizationStaffDocuments.REQUEST:
      return {
        ...state,
        LeftPanel_loading: true,
      };
    case AgencyDashboardActionTypes.get_OrganizationStaffDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
        OrganizationStaffDocuments: payload,
      };
    case AgencyDashboardActionTypes.get_OrganizationClientDocuments.REQUEST:
      return {
        ...state,
        LeftPanel_loading: true,
      };
    case AgencyDashboardActionTypes.get_OrganizationClientDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
        OrganizationClientDocuments: payload,
      };
    case AgencyDashboardActionTypes.get_StaffDocuments.REQUEST:
      return {
        ...state,
        LeftPanel_loading: true,
      };
    case AgencyDashboardActionTypes.get_StaffDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
        StaffDocuments: payload,
      };
    case AgencyDashboardActionTypes.get_ClientDocuments.REQUEST:
      return {
        ...state,
        LeftPanel_loading: true,
      };
    case AgencyDashboardActionTypes.get_ClientDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
        ClientDocuments: payload,
      };
    case AgencyDashboardActionTypes.get_masterdata.REQUEST:
        return {
          ...state,
          loading: true      
        };
    case AgencyDashboardActionTypes.get_masterdata.SUCCESS:
        return {
          ...state,
          loading: false,
          master_data: payload,
        };
    case AgencyDashboardActionTypes.get_patient.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AgencyDashboardActionTypes.get_patient.SUCCESS:
      return {
        ...state,
        patientList: payload,
        loading: false,
      };
    case AgencyDashboardActionTypes.get_OrganizationBillableHoursGraph.REQUEST:
      return {
        ...state,
        BillableKPI_loading: true,
        OrganizationBillableHoursGraph: {},
      };
    case AgencyDashboardActionTypes.get_OrganizationBillableHoursGraph.SUCCESS:
      return {
        ...state,
        BillableKPI_loading: false,
        OrganizationBillableHoursGraph: payload,
      };
    case AgencyDashboardActionTypes.get_OrganizationOAResponses.REQUEST:
      return {
        ...state,
        OAResponse_loading: true,
        OrganizationOAResponses: {},
      };
    case AgencyDashboardActionTypes.get_OrganizationOAResponses.SUCCESS:
      return {
        ...state,
        OAResponse_loading: false,
        OrganizationOAResponses: payload,
      };
    case AgencyDashboardActionTypes.get_OrganizationFinancialKPIGraph.REQUEST:
      return {
        ...state,
        FinancialKPI_loading: true,
        OrganizationFinancialKPIGraph: {},
      };
    case AgencyDashboardActionTypes.get_OrganizationFinancialKPIGraph.SUCCESS:
      return {
        ...state,
        FinancialKPI_loading: false,
        OrganizationFinancialKPIGraph: payload,
      };
    case AgencyDashboardActionTypes.get_OrganizationPayerResponses.REQUEST:
      return {
        ...state,
        PayerResponse_loading: true,
        OrganizationPayerResponses: {},
      };
    case AgencyDashboardActionTypes.get_OrganizationPayerResponses.SUCCESS:
      return {
        ...state,
        PayerResponse_loading: false,
        OrganizationPayerResponses: payload,
      };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelOARejections.REQUEST:
        return {
          ...state,
          RightPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelOARejections.SUCCESS:
      return {
        ...state,
        RightPanel_loading: false,
      };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffDocuments.REQUEST:
        return {
          ...state,
          LeftPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
      };

      case AgencyDashboardActionTypes.get_ExportCSVOrExcelClientDocuments.REQUEST:
        return {
          ...state,
          LeftPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelClientDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
      };

      case AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffNonAdminDocuments.REQUEST:
        return {
          ...state,
          LeftPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffNonAdminDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
      };

      case AgencyDashboardActionTypes.get_ExportCSVOrExcelClientNonAdminDocuments.REQUEST:
        return {
          ...state,
          LeftPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelClientNonAdminDocuments.SUCCESS:
      return {
        ...state,
        LeftPanel_loading: false,
      };

      case AgencyDashboardActionTypes.get_ExportCSVOrExcelAppointmentDocuments.REQUEST:
        return {
          ...state,
          BottonPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelAppointmentDocuments.SUCCESS:
      return {
        ...state,
        BottonPanel_loading: false,
      };

      case AgencyDashboardActionTypes.get_ExportCSVOrExcelAuthorizationDocuments.REQUEST:
        return {
          ...state,
          RightPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_ExportCSVOrExcelAuthorizationDocuments.SUCCESS:
      return {
        ...state,
        RightPanel_loading: false,
      };

      case AgencyDashboardActionTypes.get_PayerResponsesExportAsCSVAndXLS.REQUEST:
        return {
          ...state,
          RightPanel_loading: true,
        };
      case AgencyDashboardActionTypes.get_PayerResponsesExportAsCSVAndXLS.SUCCESS:
      return {
        ...state,
        RightPanel_loading: false,
      };
      case AgencyDashboardActionTypes.get_CptCodeForAuthorization.REQUEST:
      return {
        ...state,
        //Auth_loading: true,
      };
    case AgencyDashboardActionTypes.get_CptCodeForAuthorization.SUCCESS:
      return {
        ...state,
        //Auth_loading: false,
        authorizationCptCode: payload,
      };
      case AgencyDashboardActionTypes.get_AuthorizationUtilizationChart.REQUEST:
      return {
        ...state,
        Auth_loading: true,
      };
    case AgencyDashboardActionTypes.get_AuthorizationUtilizationChart.SUCCESS:
      return {
        ...state,
        Auth_loading: false,
        authorizationUtilizationChartData: payload,
      };
      case AgencyDashboardActionTypes.get_AuthorizationByPatientId.REQUEST:
        return {
          ...state,
          //Auth_loading: true,
        };
      case AgencyDashboardActionTypes.get_AuthorizationByPatientId.SUCCESS:
        return {
          ...state,
          //Auth_loading: false,
          authorizationList: payload,
        };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/Dashboards/reducers/StaffDashboardReducer.js